import { ThemeProvider } from '@ori-ui/mui';
import { ClientCultureContextProvider } from '@ori/culture-provider';
import { TestIdProvider } from '@ori/testid-generator';
import ReactDOM from 'react-dom';

import DialogApp from './DialogApp';
import { getConfiguration } from './utils/getConfiguration';

export const render = (rootElement: HTMLElement): void => {
  const { staticApiUrl, tenant, translations } = getConfiguration(rootElement);

  ReactDOM.render(
    <ThemeProvider
      enableCacheProvider
      cacheKey="ori-basket"
    >
      <ClientCultureContextProvider
        host={staticApiUrl}
        tenant={tenant}
      >
        <TestIdProvider
          team="Checkout"
          project="loyalty-dialog"
        >
          <DialogApp translations={translations} />
        </TestIdProvider>
      </ClientCultureContextProvider>
    </ThemeProvider>,
    rootElement,
  );
};
